<template>
  <v-container fluid>
    <v-card flat>
      <v-card-title>
        <v-toolbar>
          <!-- <v-icon color="brown">how_to_vote</v-icon> -->
          <v-toolbar-title class="font-weight-light">
            <v-row>
              <v-col>
                <div>&nbsp; Confirmación de Desembolso de Crédito</div>
              </v-col>
            </v-row>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.stop="hideActiveTask"
            ><v-icon>close</v-icon></v-btn
          >
        </v-toolbar>
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col>
            <v-card>
              <v-card-text>
                <v-row class="caption" no-gutters>
                  <v-col cols="9" class="font-weight-bold"
                    >TOTAL A DESEMBOLSAR</v-col
                  >
                </v-row>

                <v-divider></v-divider>
                <v-row class="caption" no-gutters>
                  <v-col cols="9" class="subtitle-1 font-weight-bold">{{
                    credito.importeALiquidar | currency
                  }}</v-col>
                </v-row>
              </v-card-text>
              <v-divider></v-divider>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text>
        <v-row>
          <v-col>
            <v-card>
              <v-card-text>
                <v-row>
                  <v-col class="font-weight-bold">Forma de Pago</v-col>
                </v-row>
                <v-row class="caption" no-gutters>
                  <v-btn-toggle v-model="model.formaDesembolsoId" mandatory>
                    <v-btn color="success" small text value="1">Efectivo</v-btn>
                    <v-btn
                      color="info"
                      small
                      text
                      value="2"
                      v-if="listMediosPago.find((i) => i.id == 2)"
                      >Transf.</v-btn
                    >
                    <v-btn
                      color="indigo"
                      small
                      text
                      value="3"
                      v-if="listMediosPago.find((i) => i.id == 3)"
                      >Giro</v-btn
                    >
                    <v-btn
                      color="error"
                      small
                      text
                      value="4"
                      v-if="listMediosPago.find((i) => i.id == 4)"
                      >Cheque</v-btn
                    >
                    <v-btn
                      color="warning"
                      small
                      text
                      value="5"
                      v-if="listMediosPago.find((i) => i.id == 5)"
                      >Tarjeta</v-btn
                    >
                  </v-btn-toggle>
                </v-row>

                <v-form v-if="model.formaDesembolsoId == '1'">
                  <ValidationObserver ref="formaDesembolso1">
                    <v-row>
                      <v-container fluid>
                        <v-row>
                          <v-col class="caption">
                            <ValidationProvider
                              name="Confirmar Importe"
                              rules="required"
                            >
                              <v-text-field
                                label="Confirmar Importe"
                                v-model="abonaCon"
                                prefix="$"
                                required
                                slot-scope="{ errors, valid }"
                                :error-messages="errors"
                                :success="valid"
                              ></v-text-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-chip v-if="erroresValidacion" color="red" dark="">
                          {{ erroresValidacion }}
                        </v-chip>
                      </v-col>
                    </v-row>
                  </ValidationObserver>
                </v-form>

                <v-form v-if="model.formaDesembolsoId == '2'">
                  <ValidationObserver ref="formaDesembolso2">
                    <v-container fluid>
                      <v-row>
                        <v-col class="caption">
                          <ValidationProvider
                            name="Confirmar Importe"
                            rules="required"
                          >
                            <v-text-field
                              label="Confirmar Importe"
                              v-model="abonaCon"
                              prefix="$"
                              required
                              slot-scope="{ errors, valid }"
                              :error-messages="errors"
                              :success="valid"
                            ></v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col class="caption">
                          <v-text-field
                            label="Banco"
                            v-model="model.banco"
                          ></v-text-field>
                        </v-col>
                        <v-col class="caption">
                          <v-text-field
                            label="Nº Identificación"
                            v-model="model.numero"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="caption">
                          <v-text-field
                            label="Comentarios"
                            v-model="model.comentarios"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </ValidationObserver>
                </v-form>

                <v-form v-if="model.formaDesembolsoId == '3'">
                  <ValidationObserver ref="formaDesembolso3">
                    <v-container fluid>
                      <v-row>
                        <v-col class="caption">
                          <ValidationProvider
                            name="Confirmar Importe"
                            rules="required"
                          >
                            <v-text-field
                              label="Confirmar Importe"
                              v-model="abonaCon"
                              prefix="$"
                              required
                              slot-scope="{ errors, valid }"
                              :error-messages="errors"
                              :success="valid"
                            ></v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col class="caption">
                          <v-text-field
                            label="Sucursal Pagadora"
                            v-model="model.banco"
                          ></v-text-field>
                        </v-col>
                        <v-col class="caption">
                          <v-text-field
                            label="Sucursal Receptora"
                            v-model="model.numero"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="caption">
                          <v-text-field
                            label="Comentarios"
                            v-model="model.comentarios"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </ValidationObserver>
                </v-form>
                <v-form v-if="model.formaDesembolsoId == '4'">
                  <ValidationObserver ref="formaDesembolso4">
                    <v-container fluid>
                      <v-row>
                        <v-col class="caption">
                          <ValidationProvider
                            name="Confirmar Importe"
                            rules="required"
                          >
                            <v-text-field
                              label="Confirmar Importe"
                              v-model="abonaCon"
                              prefix="$"
                              required
                              slot-scope="{ errors, valid }"
                              :error-messages="errors"
                              :success="valid"
                            ></v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="caption">
                          <v-text-field
                            label="Banco"
                            v-model="model.banco"
                          ></v-text-field>
                        </v-col>
                        <v-col class="caption">
                          <v-text-field
                            label="Nº Cheque"
                            v-model="model.numero"
                          ></v-text-field>
                        </v-col>
                        <v-col class="caption">
                          <v-text-field
                            label="Fecha"
                            type="date"
                            v-model="model.fechaCheque"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="caption">
                          <v-text-field
                            label="Comentarios"
                            v-model="model.comentarios"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </ValidationObserver>
                </v-form>
                <v-form v-if="model.formaDesembolsoId == '5'">
                  <ValidationObserver ref="formaDesembolso5">
                    <v-container fluid>
                      <v-row>
                        <v-col class="caption">
                          <ValidationProvider
                            name="Confirmar Importe"
                            rules="required"
                          >
                            <v-text-field
                              label="Confirmar Importe"
                              v-model="abonaCon"
                              prefix="$"
                              required
                              slot-scope="{ errors, valid }"
                              :error-messages="errors"
                              :success="valid"
                            ></v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="caption">
                          <v-text-field
                            label="Marca"
                            v-model="model.marcaTarjeta"
                          ></v-text-field>
                        </v-col>
                        <v-col class="caption">
                          <v-text-field
                            label="Nº Cupón"
                            v-model="model.numero"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="caption">
                          <v-text-field
                            label="Comentarios"
                            v-model="model.comentarios"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </ValidationObserver>
                </v-form>
              </v-card-text>
              <v-divider></v-divider>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-btn
          color="blue darken-1"
          text
          @click.stop="hideActiveTask"
          :disabled="saving"
          >Cancelar</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          color="green "
          dark
          @click.stop="save"
          :disabled="saving || corabranzaRealizada"
          >Confirmar</v-btn
        >
      </v-card-actions>
    </v-card>

    <app-loading :loading="saving"></app-loading>
  </v-container>
</template>

<script>
import Vue from 'vue';
import { http } from '@/axios';

import { Decimal } from 'decimal.js';

import { ValidationObserver, ValidationProvider } from 'vee-validate';

import { mapMutations } from 'vuex';

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data: () => ({
    editModeOn: false,
    loading: false,
    saving: false,
    corabranzaRealizada: false,
    model: {
      formaDesembolsoId: '1',
      banco: null,
      numero: null,
      comentarios: null,
      fechaCheque: null,
      marcaTarjeta: null,
    },
    abonaCon: null,
    listMediosPago: [],
    erroresValidacion: null,
  }),
  props: {
    personaId: {
      type: String,
      required: false,
      default: null,
    },
    credito: {
      type: Object,
    },
    cajaId: {
      type: Number,
    },
    fechaCaja: {
      type: String,
    },
    accionConfirmada: {
      type: Function,
    },
  },
  computed: {},
  async created() {
    await this.loadMediosPago();

    this.abonaCon = this.totalAPagar;
    this.formaPago = 'efectivo';
  },
  methods: {
    ...mapMutations([
      'hideActiveTask',
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
    ]),
    checkImporte(valor) {
      return true;
    },
    async validar() {
      this.erroresValidacion = null;

      if (this.model.formaDesembolsoId == 1) {
        var result = await this.$refs.formaDesembolso1.validate();
        console.log(result);
        if (!result) {
          return false;
        }
      }
      if (this.model.formaDesembolsoId == 2) {
        var result = await this.$refs.formaDesembolso2.validate();
        if (!result) {
          return false;
        }
      }
      if (this.model.formaDesembolsoId == 3) {
        var result = await this.$refs.formaDesembolso3.validate();
        if (!result) {
          return false;
        }
      }
      if (this.model.formaDesembolsoId == 4) {
        var result = await this.$refs.formaDesembolso4.validate();
        if (!result) {
          return false;
        }
      }
      if (this.model.formaDesembolsoId == 5) {
        var result = await this.$refs.formaDesembolso5.validate();
        if (!result) {
          return false;
        }
      }

      if (
        new Decimal(this.abonaCon).minus(
          new Decimal(this.credito.importeALiquidar)
        ) != 0
      ) {
        this.erroresValidacion =
          'El Total a Liquidar no coincide con el importe Confirmado.';
        return false;
      }
      return true;
    },
    async loadMediosPago() {
      this.loading = true;
      try {
        var result = await http.get('tiposmediopagocredito'); // traigo todas
        this.listMediosPago = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async save() {
      if (!(await this.validar())) return;

      var params = {};
      params.deudaId = this.credito.id;
      params.cajaId = this.cajaId;
      params.fechaCaja = this.fechaCaja;
      params.importe = this.abonaCon;

      params.formaDesembolsoId = this.model.formaDesembolsoId;
      params.banco = this.model.banco;
      params.numero = this.model.numero;
      params.comentarios = this.model.comentarios;
      params.marcaTarjeta = this.model.marcaTarjeta;
      params.fechaCheque = this.model.fechaCheque;
      console.log(params);

      try {
        this.saving = true;
        var res = await http.post(
          'cajas/altaegreso',
          JSON.stringify({ parametros: params })
        );
        this.corabranzaRealizada = true;

        this.alertSuccess('Se ha realizado la cobranza');
        this.accionConfirmada();
      } catch (error) {
        // Error
        this.alertError(error);
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
